/**
 * VISTOERA_PLATFORM_ADMIN_MARKETING_ANALYTICS_HOME_AND_TRACKING_FOUNDATION_V1
 * — the tiny, dependency-free storage layer shared by `marketingTracking.ts`
 * (writer, after every tracking beacon) and `saas/api.ts` (reader, to
 * attach `X-Vst-Visitor-Id` on `/auth/signup` — task spec §22). Kept in
 * its own zero-import module deliberately so neither of those two larger
 * modules ever needs to import the other (no circular import risk).
 */

export const MARKETING_VISITOR_ID_STORAGE_KEY = 'vst_visitor_id'
export const MARKETING_SESSION_ID_STORAGE_KEY = 'vst_session_id'

export function readMarketingStorageValue(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    // Private browsing / storage disabled — fail open (task spec §96/§97).
    return null
  }
}

export function writeMarketingStorageValue(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // Fail open.
  }
}

/** Read-only accessor for the current anonymous visitor id (task spec
 * §22). Returns `null` before the very first tracking beacon has ever
 * completed, or when storage is unavailable. */
export function getStoredMarketingVisitorId(): string | null {
  return readMarketingStorageValue(MARKETING_VISITOR_ID_STORAGE_KEY)
}
